<template>
<div
  v-if="payList.length"
  class="local-remittance deposit-card">
  <div class="title">{{cardName}}</div>
  <div
    v-if="currencyNav"
    class="tab-inner">
    <div class="tab-item"
      v-for="(item,index) in payListNav"
         :key="index"
         :class="{on: item.value == currency }"
         :style="getActiveStyle(item)"
         @click="currencyHandle(item)"
    >
      {{item ? item: $t('All')}}
    </div>
  </div>
  <el-row
    :gutter="15"
    class="car-list"
  >
    <el-col
      v-for="(item,index) in payListComputed"
      :key="index"
      :lg="8"
      :sm="12"
      :xs="24"
    >
      <div
        class="card-item"
        :class="{
            nouser: getIsUse(item),
            pointer: getIsUse(item),
        }"
        @click="payHandle(item)"
      >
        <div class="card-top">
          <div class="top-left">
            <img
              class="icon-img"
              :src="item.logoUrl || defaultIcon"
              alt=""
            >
            <span class="name">{{item.channelName}}</span>
          </div>
          <span
            class="top-right">
            <el-tooltip
              class="item"
              effect="dark"
              :content="$t('The_current_time_period_is_unavailable')"
              placement="top"
            >
              <i
                v-if="getIsUse(item)"
                class="iconfont icon-info icon-tips"
              ></i>
            </el-tooltip>
          </span>
        </div>
        <div class="bottom-line">
          <p v-if="limitTimeFlag">{{$t('User.timeLimit')}}: {{item.availableTime}}</p>
          <p v-if="limitMoneyFlag">{{$t('User.limit')}}: {{item.limitation}}</p>
          <p>{{$t('Currency')}}: {{item.currency}}</p>
        </div>
      </div>
    </el-col>
  </el-row>
</div>
</template>

<script>
import defaultIcon from '@/assets/images/customer/tele.png'
import { mapGetters } from 'vuex'
import {
  getUSDExRateAndFee,
  EnterMoeny,
} from '@/api/userCenter.js';
import { colorRgba,checkAuditTime } from "@/utils";
export default {
  name: "depositCard",
  props: {
    payItem: {
      type: Object,
      default(){
        return {

        }
      }
    },
  },
  data() {
    return {
      currency: '',
      payList: [],
      defaultIcon: defaultIcon,
    }
  },
  computed: {
    ...mapGetters(['userInfo','language','themeColor']),
    limitTimeFlag(){
      return this.payItem.id != 2 && this.payItem.id != 10;
    },
    limitMoneyFlag(){
      return this.payItem.id != 2 && this.payItem.id != 10;
    },
    payListNav(){
      // 需要去重
      if(!this.payList.length){
        return [];
      }else {
        let copyArr = [];
        for (let i = 0; i < this.payList.length; i++) {
          if(this.payList[i].currency.includes(',')){
            let splitArr = this.payList[i].currency.split(',');
            for (let j = 0; j < splitArr.length; j++) {
              copyArr.push(splitArr[j]);
            }
          }else {
            copyArr.push(this.payList[i].currency);
          }
        }
        let newArr = [...new Set(copyArr)];
        if(newArr.length > 1){
          newArr.unshift('');
        }
        return newArr;
      }
    },
    payListComputed(){
      if(this.currency){
        let filterList = this.payList.filter((item) => {
          return item.currency.includes(this.currency);
        });
        return filterList;
      }else if(this.currency === ''){
        return this.payList;
      }
    },
    currencyNav(){
      if(this.payItem.id == 1 || this.payItem.id == 10){
        return true;
      }else {
        return false;
      }
    },
    cardName(){
      if(this.language == 'zh_CN'){
        return this.payItem.name;
      }else if(this.language == 'en_US'){
        return this.payItem.nameEn;
      }else if(this.language == 'zh_Hant'){
        return this.payItem.nameHant;
      }
    }
  },
  created(){
    this.getChannelList();
  },
  methods: {
    getActiveStyle(item){
      if(item == this.currency){
        return {
          backgroundColor: colorRgba(this.themeColor,0.1)
        }
      }
    },
    currencyHandle(item) {
      this.currency = item;
    },

    getChannelList(){
      getUSDExRateAndFee({
        oprType: 1,
        payType: this.payItem.id,
      }).then((res) => {

        this.payList = res.data;
        // this.queryExchangeRate();
      })
    },

    getIsUse(item){
      // 08:00:00-23:59:59
      // 苹果手机有问题 已经处理了
      // 可用时间段是否包含现在时刻
      let timeArr = item.availableTime.split('-');
      let startTime = timeArr[0];
      let endTime = timeArr[1];
      return !checkAuditTime(startTime,endTime);
    },

    payHandle(item){
      if(this.getIsUse(item)){
        this.$vs.dialog({
          title: this.$t('Notice'),
          text: this.$t('User.depositTimeTips'),
          acceptText: this.$t('root.confirm')
        });
        return;
      }
      // 入金, 分几个本地汇款,2.电汇,3.USDT,4.银联购币,
      if(this.payItem.id == 1 || this.payItem.id == 11){
        // 加上perfectMoney payType == 11
        this.$router.push({name: 'onlinePayDetail', params:{ channelCode: item.channelCode}, query:{ payType: this.payItem.id } });
      }else if(this.payItem.id == 3){
        // 需要查出类型,
        if(item.sourceType == 1){
          // 也是跳转第三方的
          this.$router.push({name: 'onlinePayDetail', params:{ channelCode: item.channelCode}, query:{ payType: 3 } });
        }else {
          this.$router.push({name: 'digitalCashPayDetail', params:{ channelCode: item.channelCode }});
        }
      }else if(this.payItem.id == 10){
        // otc购币的也放到了本地汇款,中,需要上传一个手持上传图片 todo
        this.$router.push({name: 'onlinePayDetail', params:{ channelCode: item.channelCode}, query:{ payType: 10 } });
      }if(this.payItem.id == 2){
        //电汇
        this.$router.push({name: 'telegraphicPayDetail', params:{ channelCode: item.channelCode }});
      }
    }
  },
}
</script>

<style scoped>

</style>
